export type EnemyKind = 'BOT' | 'PAPER_HAND' | 'FUD_BOT' | 'LIQUIDATOR' | 'WHALE'
export type EnemyModifier = 'NONE' | 'OVERCLOCKED' | 'HARDENED' | 'REGENERATING'
export type EnemyElite = 'FIREWALL' | 'FLASH_STEP' | 'SIPHON'

export interface EnemyDefinition {
  readonly kind: EnemyKind
  readonly name: string
  readonly role: string
  readonly maxHp: number
  readonly speed: number
  readonly reward: number
  readonly coreDamage: number
  readonly armor: number
  readonly color: number
  readonly scale: number
  readonly modifier: EnemyModifier
  readonly elite?: EnemyElite
}

export const ENEMY_DEFINITIONS: Record<EnemyKind, EnemyDefinition> = {
  BOT: { kind: 'BOT', name: 'BOT', role: 'Standard process', maxHp: 80, speed: 72, reward: 90, coreDamage: 10, armor: 0, color: 0x60dfff, scale: 1, modifier: 'NONE' },
  PAPER_HAND: { kind: 'PAPER_HAND', name: 'PAPER HAND', role: 'Fast / low HP', maxHp: 48, speed: 112, reward: 70, coreDamage: 7, armor: 0, color: 0xff6d7d, scale: 0.82, modifier: 'NONE' },
  FUD_BOT: { kind: 'FUD_BOT', name: 'FUD BOT', role: 'Broadcasts speed aura', maxHp: 145, speed: 58, reward: 155, coreDamage: 13, armor: 0.08, color: 0xff3f58, scale: 1.15, modifier: 'NONE' },
  LIQUIDATOR: { kind: 'LIQUIDATOR', name: 'LIQUIDATOR', role: 'High armor / breach', maxHp: 290, speed: 45, reward: 250, coreDamage: 20, armor: 0.35, color: 0x9a78ff, scale: 1.32, modifier: 'NONE' },
  WHALE: { kind: 'WHALE', name: 'WHALE', role: 'Boss / market crash', maxHp: 1_900, speed: 30, reward: 1_500, coreDamage: 50, armor: 0.2, color: 0xff3355, scale: 2.05, modifier: 'NONE' },
}

export const ENEMY_KINDS = Object.keys(ENEMY_DEFINITIONS) as EnemyKind[]
